import { render, staticRenderFns } from "./DataAudit.vue?vue&type=template&id=47c211a2&scoped=true&"
import script from "./DataAudit.vue?vue&type=script&lang=js&"
export * from "./DataAudit.vue?vue&type=script&lang=js&"
import style0 from "./DataAudit.vue?vue&type=style&index=0&id=47c211a2&scoped=true&lang=less&"
import style1 from "./DataAudit.vue?vue&type=style&index=1&id=47c211a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c211a2",
  null
  
)

export default component.exports